// extracted by mini-css-extract-plugin
export default {"successIcon":"sidebar-actions-module__successIcon__Gf1kmsU","successText":"sidebar-actions-module__successText__aygggbU"};